/**
 * components/layout/Topbar.tsx — Phase 3 update.
 *
 * Adds the sticky DisruptionModeButton next to the queue widget for
 * ops/admin roles. Otherwise identical to the Phase 0 layout — same
 * brand lockup, same hydration heartbeat.
 */

import { useBranding } from '@/lib/branding';
// import { DisruptionModeButton } from './DisruptionModeButton';
import { UserSwitcher } from './UserSwitcher';
import { TimeModeToggle } from './TimeModeToggle';

export function Topbar(): React.JSX.Element {
  const branding = useBranding();
  return (
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-4 border-b border-border bg-background/95 px-5 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      {branding && (
        <div className="flex items-center gap-3" data-testid="topbar-tenant">
          <div className="font-mono text-2xs uppercase tracking-[0.18em] text-muted-foreground">
            Tenant
          </div>
          <div className="flex items-center gap-2">
            <span className="rounded-sm bg-qr-maroon px-1.5 py-0.5 text-[10px] font-semibold tracking-[0.16em] text-white">
              {branding.iata_code}
            </span>
            <span className="text-[13px] font-medium text-foreground">{branding.brand_name}</span>
          </div>
        </div>
      )}

      <div className="flex-1" />

      {/* <DisruptionModeButton /> */}
      <TimeModeToggle />
      <UserSwitcher />
    </header>
  );
}
